import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService, CustomQueryEncoderHelper } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()

export class ResetPasswordService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    public resetPasswordRequest(pwd){
        let serviceUrl = this.baseUrl + 'LoginService/forgotPwd';
        let headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        let options = ({ headers: headers });
        let params = ({ 
            newPass: pwd.newPassword,
            token: pwd.token,
            id: pwd.id,
            matchNewPassword: pwd.matchNewPassword
        });
        return this.http.post(serviceUrl, params, options).pipe(map(super.extractData),catchError(super.handleError));
    }

    getRules(): Observable<any> {        
        let serviceUrl = this.baseUrl + 'LoginService/rules';
        return this.http.get(serviceUrl).pipe(map(super.extractData),catchError(super.handleError));
    }

    public validateToken(token){
        let headers = new HttpHeaders({
        });

        let serviceUrl = this.baseUrl + 'LoginService/validateToken?token='+token;

        return this.http.get(serviceUrl,  { responseType: 'text',headers: headers}).pipe(catchError(super.handleError));
    }

}